import * as React from "react";
import { RES_URL } from "../../config";
import { Translation } from "../../models/models";

export interface SplashScreenProps {
  visible: boolean;
  className?: string;
  locale: Translation;
}

export interface SplashScreenState {}

export class SplashScreen extends React.Component<
  SplashScreenProps,
  SplashScreenState
> {
  constructor(props: SplashScreenProps) {
    super(props);
  }

  render() {
    let cls = this.props.className || "";
    const currentLang = (window as any).__LOCALE__;
    return (
      <div
        className={"splashscreen-container " + cls}
        data-visible={this.props.visible}
      >
        {(currentLang !== "en" && (
          <a
            href={this.props.locale.clientUrl}
            target="_blank"
            className="client-logo-container hide-on-embed"
          >
            <img
              src={RES_URL + "img/lenstore-logo-de.png"}
              alt="Kontaktlinsen mit schneller Lieferung nach Deutschland | Lenstore.de"
              className="client-logo"
            />
          </a>
        )) || (
          <a
            href={this.props.locale.clientUrl}
            target="_blank"
            className="client-logo-container hide-on-embed"
          >
            <img
              src={RES_URL + "img/lenstore-logo-uk.png"}
              alt="Contact Lenses with Fast UK Delivery | Lenstore.co.uk"
              className="client-logo"
            />
          </a>
        )}

        <table className="table-container">
          <tbody>
            <tr>
              <td>
                <div className="row">{this.props.children}</div>
              </td>
            </tr>
            <tr className="row-spacer">
              <td />
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Splashscreen/Splashscreen.tsx